export enum Filters {
  CATEGORIES = 'searchCategories',
  TAGS = 'searchTags',
  BRANDS = 'searchBrands',
}
